/**
 * .Farra countdown timer
 *
 * Custom element that ticks every second and updates its dd/hh/mm/ss slots
 * based on data-target (ISO datetime). When the target passes, replaces
 * itself with the [data-farra-countdown-live] node from within.
 *
 * Usage:
 *   <farra-countdown data-target="2026-08-15T18:00:00">
 *     <div class="farra-countdown__box"><span data-days>--</span><em>Days</em></div>
 *     <div class="farra-countdown__box"><span data-hours>--</span><em>Hrs</em></div>
 *     <div class="farra-countdown__box"><span data-minutes>--</span><em>Min</em></div>
 *     <div class="farra-countdown__box"><span data-seconds>--</span><em>Sec</em></div>
 *     <template data-farra-countdown-live>
 *       <p class="farra-countdown__live">Live now →</p>
 *     </template>
 *   </farra-countdown>
 */
class FarraCountdown extends HTMLElement {
  connectedCallback() {
    const target = this.dataset.target;
    if (!target) return;
    this.targetTime = new Date(target).getTime();
    if (Number.isNaN(this.targetTime)) return;

    this.dayEl = this.querySelector('[data-days]');
    this.hourEl = this.querySelector('[data-hours]');
    this.minEl = this.querySelector('[data-minutes]');
    this.secEl = this.querySelector('[data-seconds]');
    this.liveTemplate = this.querySelector('template[data-farra-countdown-live]');

    this.update();
    this.tick = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.tick);
  }

  update() {
    const now = Date.now();
    let diff = this.targetTime - now;

    if (diff <= 0) {
      clearInterval(this.tick);
      if (this.liveTemplate) {
        this.innerHTML = '';
        this.appendChild(this.liveTemplate.content.cloneNode(true));
      } else if (this.dayEl) {
        this.dayEl.textContent = this.hourEl.textContent = this.minEl.textContent = this.secEl.textContent = '00';
      }
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    diff -= days * 1000 * 60 * 60 * 24;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * 1000 * 60 * 60;
    const minutes = Math.floor(diff / (1000 * 60));
    diff -= minutes * 1000 * 60;
    const seconds = Math.floor(diff / 1000);

    if (this.dayEl) this.dayEl.textContent = String(days).padStart(2, '0');
    if (this.hourEl) this.hourEl.textContent = String(hours).padStart(2, '0');
    if (this.minEl) this.minEl.textContent = String(minutes).padStart(2, '0');
    if (this.secEl) this.secEl.textContent = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('farra-countdown')) {
  customElements.define('farra-countdown', FarraCountdown);
}
